var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5a1.5 1.5 0 1 1 3 0v1.088a110.85 110.85 0 0 1 4-.088c1.21 0 2.612.036 4 .088V3.5a1.5 1.5 0 0 1 3 0v1.222l.564.03a3.882 3.882 0 0 1 3.679 3.637c.127 2.04.257 4.61.257 6.611 0 2.001-.13 4.572-.257 6.611a3.882 3.882 0 0 1-3.678 3.637c-2.28.121-5.266.252-7.565.252-2.3 0-5.284-.13-7.565-.252a3.882 3.882 0 0 1-3.678-3.637C2.63 19.571 2.5 17.001 2.5 15c0-2.001.13-4.572.257-6.611a3.882 3.882 0 0 1 3.678-3.637L7 4.722V3.5Zm14.297 18.758c.515-.027.927-.435.959-.95.124-2.008.244-4.442.244-6.308 0-.617-.013-1.295-.035-2-.018-.559-.478-1-1.037-1H6.572c-.56 0-1.02.441-1.037 1a65.064 65.064 0 0 0-.035 2c0 1.866.12 4.3.244 6.309.032.514.444.922.959.949l.339.018c2.203.113 4.889.224 6.958.224s4.755-.11 6.958-.224l.34-.018Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar28);
export default __webpack_public_path__ + "static/media/calendar_28.6f16ce30.svg";
export { ForwardRef as ReactComponent };